"use client";

import {
  chakra,
  Stack,
  useColorModeValue,
  VisuallyHidden,
  Text,
} from "@chakra-ui/react";
import { FaInstagram, FaTwitter, FaSnapchat, FaTiktok } from "react-icons/fa";
import { generateSocialMediaURL } from "utils/helpers";

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={useColorModeValue("black", "white")}
      color={"white"}
      rounded={"full"}
      w={10}
      h={10}
      cursor={"pointer"}
      as={"a"}
      href={href}
      target="_blank"
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
        color: "black",
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function AboutSocialCard({ profile, firstname }) {
  const { instagram, twitter, snapchat, tiktok } = profile;
  return (
    <Stack align={"center"}>
      {instagram ? (
        <Text
          color={"black.500"}
          fontWeight={"bold"}
          fontSize={"lg"}
          fontFamily={"Yeseva"}
        >
          Follow {firstname} on social media
        </Text>
      ) : null}
      <Stack direction={"row"} spacing={6} alignContent={"center"}>
        {instagram ? (
          <SocialButton
            label={"Instagram"}
            href={generateSocialMediaURL("instagram", instagram)}
          >
            <FaInstagram />
          </SocialButton>
        ) : null}
        {twitter ? (
          <SocialButton
            label={"Twitter"}
            href={generateSocialMediaURL("twitter", twitter)}
          >
            <FaTwitter />
          </SocialButton>
        ) : null}
        {snapchat ? (
          <SocialButton
            label={"Snapchat"}
            href={generateSocialMediaURL("snapchat", snapchat)}
          >
            <FaSnapchat />
          </SocialButton>
        ) : null}
        {tiktok ? (
          <SocialButton
            label={"TikTok"}
            href={generateSocialMediaURL("tiktok", tiktok)}
          >
            <FaTiktok />
          </SocialButton>
        ) : null}
      </Stack>
    </Stack>
  );
}
